import React, { useEffect, useState } from 'react';
import { IModal } from './SpecialClauseMast';
import { Toolbar } from 'primereact/toolbar';
import { DataTable } from 'primereact/datatable';
import { Fetch } from '../../shared/Fetch';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { EmptySpecialClauseMast, ISpecialClauseMast } from './Form';

interface Iprops {
    setModal: (modal: IModal) => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
}

export const Table=(props:Iprops)=> {
        const [tableData, setTableData] = useState<ISpecialClauseMast[]>([]);

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <div className="my-2">
                    <Button label="New" icon="pi pi-plus" className="p-button-success mr-2" onClick={openNew} />
                </div>
            </React.Fragment>
        );
    };

    const openNew = () => {
        props.setModal({ open: true, singleData: EmptySpecialClauseMast });
    };
    const openEdit = (rowData: ISpecialClauseMast) => {
        props.setModal({ open: true, singleData: rowData });
    };

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">Special Clause Mast</h5>
        </div>
    );

    const loadTableData = async () => {
        const response = await Fetch('Special_Clause_Mast', "GET", null, null, props.toast);
        if (response) {
            const data = await response.json();
            setTableData(data);
        }
    }

    const ActiveStatus = (rowData: ISpecialClauseMast) => {
        return (
            <span style={{ color: rowData.status === true ? 'green' : 'red' }} className="cursor-pointer" onClick={() => { toggleVal(rowData.id) }}>{rowData.status ? "Active" : "InActive"}</span>
        );
    };


    const toggleVal = async (Id?: number) => {
        const response = await Fetch("Special_Clause_Mast/toggleStatus", "PUT", null, `Id=${Id}`, props.toast);
        if (response) {
            let message: string = " Status Changed";
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            loadTableData();
        }
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload])

    return (
        <>
            <Toolbar className="mb-1 py-0" left={leftToolbarTemplate}></Toolbar>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0" }}
                size="small" stripedRows scrollable scrollHeight="75vh"
                value={tableData}
                resizableColumns showGridlines columnResizeMode="expand"
                emptyMessage="No Requirements found."
                header={header}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="special_Clause" header="Special Clause" />
                <Column field="status" header="Status" body={ActiveStatus} />
                <Column field="" header="Action" body={(rowData: ISpecialClauseMast) => <Button icon="pi pi-pencil" className="p-button-warning mr-2" onClick={() => openEdit(rowData)} />} />
            </DataTable>
        </>
    )
}
